import camilaPhoto from "@/assets/team-camila.jpg";
import luisaPhoto from "@/assets/team-luisa.jpg";
import marceloPhoto from "@/assets/team-marcelo.jpg";
import isabelaPhoto from "@/assets/team-isabela.jpg";

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  initials: string;
  accent: string;
};

export const TEAM: TeamMember[] = [
  {
    name: "Camila Ribeiro",
    role: "Editora-chefe",
    bio: "Coordena a linha editorial da Liderança com Valores. Escreve sobre gestão de pessoas, cultura organizacional e desenvolvimento de líderes.",
    initials: "CR",
    accent: "#111111",
    photo: camilaPhoto,
  },
  {
    name: "Luísa Fontes",
    role: "Editora — Liderança e Gestão",
    bio: "Cobre pautas de liderança executiva, tomada de decisão e boas práticas de gestão em empresas de todos os portes.",
    initials: "LF",
    accent: "#3F3F46",
    photo: luisaPhoto,
  },
  {
    name: "Marcelo Andrade",
    role: "Editor — Estratégia e Negócios",
    bio: "Analisa modelos de negócio, estratégia competitiva, finanças corporativas e crescimento sustentável para empreendedores.",
    initials: "MA",
    accent: "#52525B",
    photo: marceloPhoto,
  },
  {
    name: "Isabela Prado",
    role: "Editora — Cultura e Pessoas",
    bio: "Escreve sobre cultura organizacional, times de alta performance, carreira e desenvolvimento profissional.",
    initials: "IP",
    accent: "#18181B",
    photo: isabelaPhoto,
  },
];
